import $http from '@axios';

export default {
  namespaced: true,
  state: {
    withdrawHistories: null,
    next_page_url: null,
    page: 1,
    isLoading: false,
    withdraw_customer_uuid: null,
  },
  getters: {},
  mutations: {
    SET_WITHDRAW_HISTORIES(state, value) {
      state.withdrawHistories = value;
    },
    SET_NEXT_PAGE_URL(state, value) {
      state.next_page_url = value;
    },
    SET_PAGE(state, value) {
      state.page = value;
    },
    SET_IS_LOADING(state, value) {
      state.isLoading = value;
    },
    SET_WITHDRAW_CUSTOMER_UUID(state, value) {
      state.withdraw_customer_uuid = value;
    },
    ADD_WITHDRAW_HISTORIES(state, value) {
      state.withdrawHistories.push(value);
    },
  },
  actions: {},
};
